import { VENDOR_GENERATE_QR, VENDOR_GENERATE_QR_SUCCESS, VENDOR_GENERATE_QR_ERROR, VENDOR_GENERATE_QR_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorGenerateQr = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_GENERATE_QR:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_GENERATE_QR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case VENDOR_GENERATE_QR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_GENERATE_QR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorGenerateQr;
